import {appAPI} from "../../../api";
import {IBackupItem} from "../../../models/IBackup";

const backupPath = `/backup`;

export const backupAPI = {
    getAll: async (): Promise<IBackupItem[]> => {
        const res = await appAPI.get(backupPath);
        return res.data;
    },
    run: async (): Promise<{ created: string }> => {
        const res = await appAPI.post(`${backupPath}/run`);
        return res.data;
    },
    restore: async (key: string): Promise<{ restored: string }> => {
        const res = await appAPI.post(`${backupPath}/restore`, {key});
        return res.data;
    },
    getDownloadUrl: async (key: string): Promise<{ url: string }> => {
        const res = await appAPI.get(`${backupPath}/download`, {
            params: {key},
        });
        return res.data;
    },
};